import {
  GET_OFFER_REQUEST_BY_ID,
  IS_LOADING_SAVE,
  GET_OFFER_REQUESTS,
} from "./types";

const initialState = {
  loadingSave: false,
  currentOfferRequest: null,
  offerRequests: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_REQUESTS:
      return {
        ...state,
        offerRequests: action.payload,
      };
    case IS_LOADING_SAVE:
      return {
        ...state,
        loadingSave: action.payload,
      };
    case GET_OFFER_REQUEST_BY_ID:
      return {
        ...state,
        currentOfferRequest: action.payload,
      };
    default:
      return state;
  }
};
